import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const SelectStyles = styled("div")({
  "& .MuiOutlinedInput-root": {
    borderRadius: 100,
  },
  "& .MuiOutlinedInput-root fieldset legend, & label.MuiInputLabel-root": {
    display: "none",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    top: 0,
  },
});
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    anchororigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    transformorigin: {
      vertical: "top",
      horizontal: "left",
    },
    style: {
      maxHeight: ITEM_HEIGHT * 3 + ITEM_PADDING_TOP,
      maxWidth: 150,
    },
  },
};

//Select Dropdown Props
interface Option {
  optionColor?: string | undefined;
  value: string;
  label: string;
}
interface SelectFieldProps {}

interface SelectFieldProps {
  name: string;
  id: string;
  value?: any;
  options: Option[];
  dataTestId?: string;
  style?: any;
  isMulti?: boolean;
  required?: boolean;
  errorMessage?: any;
  label?: string;
  onChange?: (option: any, e: any) => void;
  onClick?: (option: any, e: any) => void;
  disabled?: any;
  onBlur?: any;
  error?: any;
  defaultValue?: any;
  optionColor?: any;
  className?: any;
  optionColorClass?: any;
  ref?: any;
  setPharmacyCodeOptionClass?: any;
}

//Select Core Component
export const DRxSelect2: React.FC<SelectFieldProps> = ({
  id,
  value,
  options,
  dataTestId,
  required,
  errorMessage,
  label,
  defaultValue,
  onChange,
  onClick,
  disabled,
  optionColor,
  optionColorClass,
  className,
  ref,
  setPharmacyCodeOptionClass,
  ...props
}) => {
  return (
    <FormControl {...props}>
      <Select
        disabled={disabled}
        required={required}
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        id={id}
        data-testid={dataTestId}
        label={label}
        ref={ref}
        sx={{
          borderRadius: 100,
        }}
        MenuProps={MenuProps}
        className={optionColorClass}
      >
        {options.map((item: any) => (
          <MenuItem
            key={item.value}
            value={item.value}
            className={item.optionColor}
            onClick={() => {
              setPharmacyCodeOptionClass &&
                setPharmacyCodeOptionClass(item.optionColor);
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {errorMessage && (
        <Typography
          color="error"
          className="error"
          variant="body2"
          component="div"
        >
          {errorMessage}
          {/* <ErrorMessage name={props.name} /> */}
        </Typography>
      )}
    </FormControl>
  );
};
